import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_STATUS_RESET = 'PUT_ROUTE_STATUS_RESET';
export const PUT_ROUTE_STATUS_LOADING = 'PUT_ROUTE_STATUS_LOADING';
export const PUT_ROUTE_STATUS_SUCCESS = 'PUT_ROUTE_STATUS_SUCCESS';
export const PUT_ROUTE_STATUS_REJECT = 'PUT_ROUTE_STATUS_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteStatusReset = () => ({ type: PUT_ROUTE_STATUS_RESET });
export const putRouteStatusLoading = () => ({ type: PUT_ROUTE_STATUS_LOADING });
export const putRouteStatusSuccess = (payload) => ({ type: PUT_ROUTE_STATUS_SUCCESS, payload });
export const putRouteStatusReject = (payload) => ({ type: PUT_ROUTE_STATUS_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteStatusRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Route/web/AddRouteChangeStatus/${data.idRoute}`, options);
};

